var $mainSlider = $('#main-slider');

if ($mainSlider.length) {
    $('#main-slider-prev, #main-slider-next').on('click', function() {
        return false;
    });

    $('#main-slider-prev').on('click', function() {
        $mainSlider.slick('slickPrev');
    });

    $('#main-slider-next').on('click', function() {
        $mainSlider.slick('slickNext');
    });




    $mainSlider
        .on('init', function(event, slick) {
            $(event.target).parent().removeClass('is-cropped');
        })
        .slick({
            arrows: false,
            infinite: true,
            speed: 200,
            slidesToShow: 5, // TODO(ve): https://github.com/kenwheeler/slick/issues/1207
            variableWidth: true
        });
}